/* Página de discussão do Fórum, onde são listados os tópicos de discussão. Ao clicar no tópico principal do f'órum, o usuário é redirecionado para a página de comentários, onde pode visualizar as postagens e respostas relacionadas ao tópico selecionado.
*/

import ListaForumComentarios from "../../componentes/ListaForumComentarios";


const ListagemForumComentarios = () => {
    return (
        <div>
            <div className="container-fluid mt-3">
                <ListaForumComentarios/>
            </div>
        </div>
    )}

export default ListagemForumComentarios;